/* eslint-disable no-use-before-define */
import {ajax, getBrand, isCusip, arrayFrom, parseDate, getOwaTcdaoContext} from '../twd'

export const getBondInfo = async ({cusip, holdings}) => {
    if (!cusip) return null

    if (!isCusip(cusip)) {
        throw new Error('invalid cusip')
    }

    const { data:bond_, } = await ajax({
        url: '/esb/retailservice/bondDetailService/getIssueDesc',
        method: 'POST',
        params: ({
            p_cusip: cusip,
            p_id_type: 'I',
            p_brand: getBrand(),
            p_alloc_id: '',
            p_watch_id: '',
            p_ngw: 'Y',
        })
    })

    const bond = await bond_
    const issue = bond.issue = bond.issue || {}
    issue.prospectus = (() => {
        const t = issue && issue.researchLinks;
        if (!t) {
            return
        }
        if (t.indexOf('LEGAL(' + issue.cusip + ')') < 0 && t.indexOf('SALES(' + issue.cusip + ')') < 0) {
            return
        }

        const a = t.indexOf('BDResearch.showViewer(');
        const s = t.substring(a, t.indexOf(')', a));
        const u = String(s).replace("BDResearch.showViewer('", '').replaceAll("'", '');
        const owaTcDaoContext = getOwaTcdaoContext()
        return u ? 'https://www.bonddesk.com/etrade/' + owaTcDaoContext + '/' + u : '';
    })()

    const {data:book_, } = await ajax({
        url:'/esb/portfolio/cusip/warningAndBook',
        method: 'POST',
        params: {
            "p_criteria_fmt":"ADVANCED",
            "p_cusip": cusip,
            "p_maxrows":1,
            "p_monarch":"Y",
            "p_output_fmt":"JSON",
            "p_multiple":["BOL-UOR","BOL-ROR"],
            "p_submit":"JSON",
            "p_redirect_output":"Y",
            "p_type":"0",
            "p_min_qty":1,
            "p_is_offer_search":false,
            "p_search_criteria":{},
            "p_mode":"RP"
        }
    })

    const book = (await book_)[0] || {}
    bond.issue.showBook = book.showBook
    bond.issue.allowTrading =  book.allowTrading
    bond.issue.warningText = book.warningText

    const {data:settle_} = await ajax({
        url:'/esb/retailservice/dates/tradeAndSettlement',
        method: 'POST',
        params: {cusip}
    })

    let cs = (await settle_)
    if (cs) {
        bond.settlement = cs.settleDate
    }

    const { type, category, callableInd, couponTypeCode } = issue || {}
    bond.isMBS = ['O','R','K'].indexOf(type)>=0
    bond.isRestricted = bond.isMBS
        || (type==='P')
        || (type==='C' && category==='N')
        || (type==='S' && category==='N')

    bond.holdings = arrayFrom(holdings)
        .filter(({cusip:a}) => a===cusip)
    bond.isHeld = bond.holdings.length > 0
    const mat = parseDate(bond.issue.maturity)
    const now = Date.now()
    bond.isMatured = mat && mat<now
    bond.hasAsk = book.allowTrading && bond.bestoffer && bond.bestoffer.ask && bond.bestoffer.ask.id
    bond.hasBid = book.allowTrading && bond.bestoffer && bond.bestoffer.bid && bond.bestoffer.bid.id
    bond.canCalc = !bond.isRestricted
        && couponTypeCode!=='E'
        && couponTypeCode!=='0'
    bond.canTrade = book.allowTrading && !bond.isMatured
    bond.isCallable = callableInd==='Y' && !bond.isMBS
    return bond
}